export interface BasketOwner {
  userID: number;
  userName: string;
  email: string;
  totalQuantity: number;
  updatedAt: Date;
  lastNotifiedAt?: Date;
}

export const basketOwnerFromResponse = (responseData: any): BasketOwner => ({
  userID: responseData.user_id,
  userName: responseData.user_name,
  email: responseData.email,
  totalQuantity: responseData.total_quantity,
  updatedAt: new Date(responseData.updated_at),
  lastNotifiedAt: responseData.last_notified_at
    ? new Date(responseData.last_notified_at)
    : undefined,
});
